import { SVGProps } from 'react';

export default (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="348"
    height="46"
    viewBox="0 0 348 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="348" height="46" rx="2" fill="#F6F6F6" />
    <ellipse cx="16.0444" cy="23" rx="8.02228" ry="8" fill="#BBBBBB" />
    <ellipse cx="332.022" cy="23" rx="8.02228" ry="8" fill="#BBBBBB" />
    <mask id="path-4-inside-1_1023_100471" fill="white">
      <rect x="87" y="15" width="16.0446" height="16" rx="1" />
    </mask>
    <rect
      x="87"
      y="15"
      width="16.0446"
      height="16"
      rx="1"
      fill="white"
      stroke="#0696D7"
      strokeWidth="4"
      mask="url(#path-4-inside-1_1023_100471)"
    />
    <mask id="path-5-inside-2_1023_100471" fill="white">
      <rect x="166" y="15" width="16.0446" height="16" rx="1" />
    </mask>
    <rect
      x="166"
      y="15"
      width="16.0446"
      height="16"
      rx="1"
      fill="white"
      stroke="#666666"
      strokeWidth="4"
      mask="url(#path-5-inside-2_1023_100471)"
    />
    <mask id="path-6-inside-3_1023_100471" fill="white">
      <rect x="245" y="15" width="16.0446" height="16" rx="1" />
    </mask>
    <rect
      x="245"
      y="15"
      width="16.0446"
      height="16"
      rx="1"
      fill="white"
      stroke="#0696D7"
      strokeWidth="4"
      mask="url(#path-6-inside-3_1023_100471)"
    />
    <path
      d="M83 24L78 21.1133L78 26.8868L83 24ZM28 24.5L78.5 24.5L78.5 23.5L28 23.5L28 24.5Z"
      fill="#999999"
    />
    <path
      d="M162 24L157 21.1133L157 26.8868L162 24ZM107 24.5L157.5 24.5L157.5 23.5L107 23.5L107 24.5Z"
      fill="#999999"
    />
    <path
      d="M241 24L236 21.1133L236 26.8868L241 24ZM186 24.5L236.5 24.5L236.5 23.5L186 23.5L186 24.5Z"
      fill="#999999"
    />
    <path
      d="M320 24L315 21.1133L315 26.8868L320 24ZM265 24.5L315.5 24.5L315.5 23.5L265 23.5L265 24.5Z"
      fill="#999999"
    />
  </svg>
);
